import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllQuestionsUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllQuestions implements GetAllQuestionsUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: GetAllQuestionsUseCaseInterface.Params,
  ): Promise<GetAllQuestionsUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/list?criteriaId=${params.criteriaId}`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
